module.exports = __webpack_public_path__ + "dd95e935c90e845bdb2b4e3c26784e96.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/ear-muffs-red.png
// module id = 2797
// module chunks = 0